export const ELASTIC_TEMPLATES = {
  CITATIONS: 'dev-citations-search',
} as const
